import React, { Component } from 'react';

class Category extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    return (
      <div id="Category">
        <h3>{this.props.cat.toUpperCase()}</h3>
        <img src={this.props.assets.pic.full} alt={this.props.txt} className="catImgFull" />
        <img src={this.props.assets.pic.mobile} alt={this.props.txt} className="catImgMobile" />
      </div>
    );
  }
}

export default Category;


// WEBPACK FOOTER //
// ./src/components/Category.jsx